/* globals jui, Class */
var _             = require('lodash');
var jQuery        = require('jquery');
var h             = require('virtual-dom/h');
var diff          = require("virtual-dom/diff");
var patch         = require('virtual-dom/patch');
var createElement = require('virtual-dom/create-element');

var VersionControlDialog = Class.create(jui.ModalDialog, {
  initialize: function($super, options) {
    options = _.merge({
      title                : 'Version Control',
      clickOutsideWillClose: true,
      allowHeader          : true,
      showCancelButton     : true,
      closeX               : true,
      attributes           : {
        className          : 'modal-panel version-control-panel'
      },
    }, options);

    options.actions = this._buildActions(options);

    this.lastRestorePosition = options.lastRestorePosition;

    $super(options);
    this.show();
  },

  _buildActions: function(options) {
    var self = this;
    var actions = [];

    if (options.showCancelButton) {
      actions.push({
        attributes: {
          id: 'close',
          className: 'button modal-button push-left'
        },
        type: 'button',
        label: 'Cancel',
        action: function() {
          self.close();
        }
      });
    }

    actions.push({
      attributes: {
        id: 'restore',
        className: 'button modal-button action dsbl'
      },
      type: 'button',
      label: 'Restore',
      action: function() {
        if ( ! _.isEmpty(self.selectedValue)) {
          self.options.onRestore(self.selectedValue);
        }
      }
    });

    return actions;
  },

  installUI: function($super) {
    $super();
    this.setTitle(this.options.title);
    this.setContent(this.render(this.options));
  },

  _buildContentTree: function(state, menuItems) {
    var self = this;
    var subHeading = h('span.sub-heading', 'Select a version of your page to restore.');
    var contentTitle = h('span.content-title', 'Revision History');
    var contentTree = [subHeading, contentTitle];

    if (state === 'loading') {
      contentTree.push(h('span.version-control-item', 'Loading...'));

    } else if (state === 'loadError') {
      contentTree.push(h('span.version-control-item', 'Error: Could not load historical save list'));

    } else if (menuItems.length === 0) {
      contentTree.push(h('span.version-control-item', 'No historical save data was found.'));

    } else {
      var currentSavePomPath = this.lastRestorePosition;
      var currentSaveIndex = _.findIndex(menuItems, function(pomSave) {
        return pomSave.value === currentSavePomPath;
      });

      var activeIndex = ( ! currentSavePomPath || currentSaveIndex === -1) ? 0 : currentSaveIndex;

      var selectList = _.map(menuItems, function(menuItem, index) {
        var itemClass = 'div.version-control-item';

        // If the user is jumping between saves, the active item will be the one they selected
        // from the last restore
        if (index === activeIndex) {
          itemClass = 'div.version-control-item.active';
          self.selectedValue = menuItem.value;
        }

        return h(itemClass, {
          onclick: function() {
            jQuery('.version-control-item').removeClass('active');
            this.addClassName('active');
            self.selectedValue = menuItem.value;
          },
          ondblclick: function() {
            self.options.onRestore(menuItem.value);
          }
        }, menuItem.label);
      });

      contentTree.push(h('div.version-control-modal-selection', selectList));
    }

    return contentTree;
  },

  _updateRestoreButtonState: function(state) {
    jQuery('.action-bar #restore').toggleClass('dsbl', state !== 'loaded');
  },

  render: function(options) {
    var menuItems = (options && options.menuItems) ? options.menuItems : [];
    var contentsTree = this._buildContentTree(options.state, menuItems);
    var newTree = h('.version-control-content-container', contentsTree);

    if (this.currentTree) {
      var patches = diff(this.currentTree, newTree);
      this.rootNode = patch(this.rootNode, patches);
    } else {
      this.rootNode = createElement(newTree);
    }

    this.currentTree = newTree;

    this._updateRestoreButtonState(options.state);

    return this.rootNode;
  },

  close: function($super) {
    $super();
    this.fireEvent('closed');
  },

  scrollToActiveItem: function() {
    var $container = jQuery('.version-control-modal-selection');
    var $activeItem = jQuery('.version-control-item.active');

    if ($container.length && $activeItem.length) {
      var containerTop = $container.offset().top;
      var activeItemTop = jQuery('.version-control-item.active').offset().top;

      $container.scrollTop(activeItemTop - containerTop - 10);
    }
  },

  safeOpen: function() {
    // Opens the dialog through the dialog manager, which ensures multiple dialogs aren't
    // open at the same time, which isn't supported and leads to errors
    if (window.editor.dialogManager) {
      window.editor.dialogManager.openDialog(this);
    } else {
      this.open();
    }

    this.options.onOpen();
  }
});

module.exports = VersionControlDialog;



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/version-control-dialog.js